import { ComponentType, SVGProps } from 'react';
import { MouseIcon, StoreIcon } from '../../../assets/icons';

export type Channel = 'loja_fisica' | 'loja_online';

type ChannelConfig = {
  icon: ComponentType<SVGProps<SVGSVGElement>>;
  title: string;
  description: string;
};

/** Ícone, título e descrição de cada canal — usado pelos cards selecionáveis da etapa 2. */
export const CHANNEL_CONFIG: Record<Channel, ChannelConfig> = {
  loja_fisica: {
    icon: StoreIcon,
    title: 'Loja Física',
    description: 'Atendimento presencial na loja',
  },
  loja_online: {
    icon: MouseIcon,
    title: 'Loja Online',
    description: 'Atendimento via Site ou App',
  },
};

export const CHANNELS = Object.keys(CHANNEL_CONFIG) as Channel[];

export function isChannel(value: string): value is Channel {
  return (CHANNELS as string[]).includes(value);
}
